import completeQuickCreation from 'actions/salon/completeQuickCreation.action';
import postQuickSalonData from 'actions/salon/postQuickSalonData.action';
import postSalonData from 'actions/salon/postSalonData.action';
import SEGMENT from 'config/segment.singleton';
import QST from 'constants/quickSetupType.const';
import getAnyOrVoid from 'utils/accessors/getAnyOrVoid.util';
import { selectCognitoUserName } from 'utils/cognito.util';
import getState from 'utils/core/getState.util';
import refreshTokens from 'utils/core/refreshTokens.util';
import withOptions from 'utils/functions/withOptions.util';
import logger from 'utils/logger.util';

const L = logger('postSalonDataAndRefreshTokens');

const postSalonDataAndRefreshTokens = L.wrap(
  '()',
  withOptions(({ data, type, quick }) => async (dispatch) => {
    try {
      const salonResult = quick
        ? await dispatch(postQuickSalonData({ data, type: type || QST.hair }))
        : await dispatch(postSalonData(data));

      const username = selectCognitoUserName(getState());
      const salonId = getAnyOrVoid('response.id', salonResult);
      const companyName = getAnyOrVoid('response.name', salonResult);

      await refreshTokens({ salonId, companyName, force: true });

      if (salonId || companyName) {
        L.debug('()', { username, salonId, companyName });

        // was SEGMENT.identify({ id: username, traits: { company: { id: salonId, name: companyName } } });
        SEGMENT.setCompany({ username, id: salonId, name: companyName });
      }

      if (quick) {
        await dispatch(completeQuickCreation());
      }

      return salonResult;
    } catch (e) {
      throw L.warn('()', { data, type, quick }, e);
    }
  }),
);

// noinspection JSUnusedGlobalSymbols
export default postSalonDataAndRefreshTokens;
